import { ChangeEvent } from 'react'
import { customReportsApi } from '~/api/reports'
import { ReportType } from '~/custom_reports/types'
import { useErrorModal, useSuccessToast, FavoriteCheckbox } from '~/design_system'

function useAddAndDeleteFavorites() {
  const successToast = useSuccessToast()
  const unexpectedError = useErrorModal()

  function addToFavorites(id: number, name: string, report_type: ReportType, show_toast: boolean) {
    const favorites = [
      {
        report_title: name,
        report_id: id,
        report_type,
        ui_class: 'custom_report_link'
      }
    ]
    customReportsApi
      .saveFavorites({ favorites })
      .then(() => {
        if (show_toast) successToast('Added to favorites')
      })
      .catch(() => unexpectedError.showModal())
  }

  function deleteFavorite(id: number, report_type: ReportType, show_toast: boolean) {
    customReportsApi
      .deleteFavorite({ report_key: id, report_type })
      .then(() => {
        if (show_toast) successToast('Removed from favorites')
      })
      .catch(() => unexpectedError.showModal())
  }

  return { addToFavorites, deleteFavorite }
}

interface FavoriteReportCheckboxProps {
  id: number
  reportType: ReportType
  name: string
  isFavorite: boolean
  showToast?: boolean
}

export default function FavoriteReportCheckbox({
  id,
  reportType,
  name,
  isFavorite,
  showToast = false
}: FavoriteReportCheckboxProps) {
  const { addToFavorites, deleteFavorite } = useAddAndDeleteFavorites()

  const toggleFavorite = (e: ChangeEvent<HTMLInputElement>) => {
    const wasChecked = e.target.checked
    if (wasChecked) {
      addToFavorites(id, name, reportType, showToast)
    } else {
      deleteFavorite(id, reportType, showToast)
    }
  }

  return (
    <FavoriteCheckbox
      id={`tool_tip_${id}_${reportType}`}
      defaultChecked={isFavorite}
      onChange={toggleFavorite}
      onClick={e => e.stopPropagation()}
    />
  )
}
